import moment from "moment";

import { Direction, Range, ThumbRangeDaysWidth } from "./types";

const MIN_DAY_WIDTH = 1;

const getDayWidth = (value): number => Math.max(value, MIN_DAY_WIDTH);
export const getDaysInRangeIncludingEndDate = (start, end): number => moment(end).diff(start, "days") + 1;

// Calculates single day width on both sides of scroll thumb
export const calculateRangeDaysWidth = (
  thumbWidth: number,
  thumbLeft: number,
  range: Range,
  calendarStartDate: string,
  calendarEndDate: string,
  offsetWidth: number
): ThumbRangeDaysWidth => {
  const daysInRange = getDaysInRangeIncludingEndDate(range.start, range.end);
  const daysFromCalendarStartToThumbStart = getDaysInRangeIncludingEndDate(calendarStartDate, range.start);
  const daysFromThumbEndToCalendarEnd = getDaysInRangeIncludingEndDate(range.end, calendarEndDate);
  const widthFromThumbEndToCalendarEnd = offsetWidth - thumbLeft - thumbWidth;
  return {
    [Direction.Right]: {
      back: getDayWidth(thumbWidth / daysInRange),
      forward: getDayWidth(widthFromThumbEndToCalendarEnd / daysFromThumbEndToCalendarEnd)
    },
    [Direction.Left]: {
      back: getDayWidth(thumbLeft / daysFromCalendarStartToThumbStart),
      forward: getDayWidth(thumbWidth / daysInRange)
    }
  };
};
